<template>
  <div>
    <data-table
      :data="shippingRequests"
      :is-hoverable="isHoverable"
      :is-focusable="isFocusable"
      :perPage="perPage"
      :total="total"
      :currentPage="currentPage"
      :isPaginated="isPaginated"
      :backEndPagination="isBackendPaginated"
      :onPageChange="onPageChange"
      :defaultSort="defaultSort"
      :defaultSortDirection="defaultSortDirection"
      class= "table"
    >
      <template slot-scope="props">
        <b-table-column
          field="id"
          label="Ref No."
          centered
          numeric
          sortable
          v-if="props.row.ref_no"
        >
          <router-link
            :to="{
              name: 'shipping-application-details',
              params: { id: props.row.id }
            }"
            v-if="canViewShippingRequest"
          >
            <a>{{ props.row.ref_no }}</a>
          </router-link>
          <span v-else>{{props.row.ref_no}}</span>
        </b-table-column>

        <b-table-column
          v-if="props.row.shipper_declaration_date"
          field="shipper_declaration_date"
          label="Date Of Submission"
          sortable
          centered
        >{{ props.row.shipper_declaration_date | moment("DD-MM-YYYY") }}</b-table-column>

        <b-table-column v-if="props.row.status" field="status" label="Status" sortable>
          <span
            v-if="props.row.status.toLowerCase()=='approved'"
            class="status"
            :class="props.row.status.toLowerCase()"
          >approved</span>
          <span
            v-if="props.row.status.toLowerCase()=='pending_approval'"
            class="status pending"
          >pending</span>
          <span
            v-if="props.row.status.toLowerCase()=='awaiting_processing'"
            class="status pending"
          >pending</span>
          <span
            v-if="props.row.status.toLowerCase()=='completed'"
            class="status completed"
          >Completed</span>
          <span
            v-if="props.row.status.toLowerCase()=='disapproved'"
            class="status rejected"
          >Rejected</span>
          <span
            v-if="props.row.status.toLowerCase()=='failed_processing'"
            class="status rejected"
          >Rejected</span>
        </b-table-column>

        <b-table-column field="dg_total" label="No. Of DG" sortable v-if="props.row.dg_total">
          <span>{{ props.row.dg_total }}</span>
        </b-table-column>

        <b-table-column v-if="props.row.date" field="date" label="Date" centered sortable>
          <span class="tag is-success">{{ new Date(props.row.date) }}</span>
        </b-table-column>

        <b-table-column
          v-if="props.row.date_submitted"
          field="date"
          label="Date Submitted"
          centered
          sortable
        >
          <span class="tag is-success">
            {{
            new Date(props.row.date_submitted).toLocaleDateString(
            "de-DE",
            options
            )
            }}
          </span>
        </b-table-column>

        <b-table-column
          v-if="props.row.arrival_date"
          field="date"
          label="Arrival Date"
          centered
          sortable
        >
          <span class="tag is-success">{{ props.row.arrival_date | moment("DD-MM-YYYY") }}</span>
        </b-table-column>

        <b-table-column
          v-if="props.row.departure_date"
          field="date"
          label="Departure Date"
          centered
          sortable
        >
          <span class="tag is-success">{{ props.row.departure_date | moment("DD-MM-YYYY") }}</span>
        </b-table-column>

        <b-table-column
          v-if="props.row.expected_date"
          field="date"
          label="Expected Date"
          centered
          sortable
        >
          <span class="tag is-success">{{ props.row.expected_date | moment("DD-MM-YYYY")}}</span>
        </b-table-column>

        <b-table-column
          v-if="props.row.user_id"
          field="user_id"
          label="User ID"
        >{{ props.row.user_id }}</b-table-column>

        <b-table-column
          v-if="props.row.ship_name"
          field="ship_name"
          label="Name of Vessel"
        >{{ props.row.ship_name }}</b-table-column>

        <b-table-column
          v-if="props.row.shipper_name"
          field="shipper_name"
          label="Name of Shipper"
        >{{ props.row.shipper_name }}</b-table-column>

        <b-table-column
          v-if="props.row.shipper_address"
          field="shipper_address"
          label="Shipper Address"
        >{{ props.row.shipper_address }}</b-table-column>
        <b-table-column
          v-if="props.row.shipper_phone_number"
          field="shipper_phone_number"
          label="Shipper Phone Number"
        >{{ props.row.shipper_phone_number }}</b-table-column>

        <b-table-column
          v-if="props.row.consignee_address"
          field="consignee_address"
          label="Consignee Address"
        >{{ props.row.consignee_address }}</b-table-column>

        <b-table-column
          v-if="props.row.consignee_name"
          field="consignee_name"
          label="Name of Consignee"
        >{{ props.row.consignee_name }}</b-table-column>
        <b-table-column
          v-if="props.row.number_of_dg_commodities_coloaded_in_container"
          field="number_of_dg_commodities_coloaded_in_container"
          label="No. Of Coloaded Commodities"
        >{{ props.row.number_of_dg_commodities_coloaded_in_container }}</b-table-column>

        <b-table-column
          v-if="props.row.port_of_discharge_id"
          field="port_of_discharge_id"
          label="Port of Discharge ID"
        >{{ props.row.port_of_discharge_id }}</b-table-column>

        <b-table-column
          v-if="props.row.port_of_loading"
          field="port_of_loading"
          label="Port of Loading"
        >{{ props.row.port_of_loading }}</b-table-column>

        <b-table-column
          v-if="props.row.shipper_declaration_company_name"
          field="shipper_declaration_company_name"
          label="Shipper Declaration Company Name"
        >{{ props.row.shipper_declaration_company_name }}</b-table-column>

        <b-table-column
          v-if="props.row.shipper_declaration_name_of_declarant"
          field="shipper_declaration_name_of_declarant"
          label="Shipper Declaration Name of Declarat"
        >{{ props.row.shipper_declaration_name_of_declarant }}</b-table-column>

        <b-table-column
          v-if="props.row.shipper_declaration_status_of_declarant"
          field="shipper_declaration_status_of_declarant"
          label="Shipper Declaration Status of Declarat"
        >{{ props.row.shipper_declaration_status_of_declarant }}</b-table-column>

        <b-table-column
          v-if="props.row.container_id"
          field="container_id"
          label="Container ID"
        >{{ props.row.container_id }}</b-table-column>

        <b-table-column
          v-if="props.row.voyage_number"
          field="voyage_number"
          label="Voyage Number"
        >{{ props.row.voyage_number }}</b-table-column>

        <b-table-column
          v-if="props.row.certificate_id"
          field="certificate_id"
          label="Certificate ID"
        >{{ props.row.certificate_id }}</b-table-column>

        <b-table-column
          v-if="props.row.form_details"
          field="reference_number"
          label="Reference Number"
        >{{ props.row.form_details.reference_number}}</b-table-column>

        <b-table-column
          v-if="props.row.created_at"
          field="created_at"
          label="Saved On"
        >{{ props.row.created_at | moment("dddd, MMMM Do YYYY, h:mm a") }}</b-table-column>

        <!-- Row Actions eg View Update and other actions can be placed here -->

        <b-table-column field="actions" label="Actions" centered>
          <div class="columns is-mobile">
            <!-- View the Shipping Request -->
            <div class="column" v-if="canViewShippingRequest">
              <b-tooltip label="View the shipping request" position="is-left" multilined>
                <a class="action-item" @click.prevent="viewShippingRequest(props.row.id)">
                  <b-icon type="is-primary" icon="eye"></b-icon>
                  <span class="action-text">View</span>
                </a>
              </b-tooltip>
            </div>

            <div class="column" v-if="savedShippingRequest">
              <b-tooltip label="Continue this saved application" position="is-left" multilined>
                <a class="action-item" @click.prevent="onContinueShippingRequest(props.row)">
                  <b-icon type="is-primary" icon="page-next"></b-icon>
                  <span class="action-text">Continue</span>
                </a>
              </b-tooltip>
            </div>
          </div>
        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="alert-box" size="is-large"></b-icon>
            </p>
            <h2>No Shipping applications to display.</h2>
          </div>
        </section>
      </template>
    </data-table>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
  </div>
</template>

<script>
import DataTable from "@/modules/commonModule/components/dataTable/Main";
import ViewShippingRequestDetails from "@/modules/shippersModule/views/ShippingApplicationDetails";
import ConfirmContinueSavedRequestCard from "./ConfirmContinueSavedRequestCard";
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapMutations } = createNamespacedHelpers("shippers");
import {
  mapGetters as mapRootGetters,
  mapMutations as mapRootMutations
} from "vuex";

import {
  SHIPPER_MUTATION_TYPES,
  ROOT_MUTATION_TYPES
} from "@/store/mutation-types";
import GetPortsAndDangerousGoodsInfoQuery from "@/modules/commonModule/api/graphql/queries/GetPortsAndDangerousGoodsInfo";

export default {
  name: "ShippingRequests",

  components: {
    DataTable,
    ViewShippingRequestDetails,
    ConfirmContinueSavedRequestCard
  },

  props: {
    shippingRequests: { type: Array, required: true },
    canUpdatePortStatus: { type: Boolean, default: false },
    canViewShippingRequest: { type: Boolean, default: false },
    canContinueSavedRequest: { type: Boolean, default: false },
    savedShippingRequest: { type: Boolean, default: false },
    defaultSort: { type: Array },
    defaultSortDirection: { type: String },
    isPaginated: { type: Boolean, default: true },
    isBackendPaginated: { type: Boolean, default: true },
    total: { type: Number, default: 0 },
    perPage: { type: Number, default: 10 },
    currentPage: { type: Number, default: 1 },
    onPageChange: {
      type: Function,
      default: () => {
        console.log("Empty onPageChange called from Shipping  Request List");
      }
    }
  },

  data() {
    return {
      isHoverable: true,
      isLoading: false,
      isFocusable: false
      // currentPage: 1
    };
  },

  computed: {
    ...mapGetters({
      dangerousGoodsInfo: "getDangerousGoodsInfo"
    }),
    ...mapRootGetters({
      portsFromVuex: "getPorts"
    })
  },

  methods: {
    ...mapRootMutations({
      updatePorts: ROOT_MUTATION_TYPES.SAVE_PORTS
    }),
    ...mapMutations({
      continueShippingRequest:
        SHIPPER_MUTATION_TYPES.CONTINUE_SAVED_SHIPPING_REQUEST,
      updateDangerousGoodsInfo:
        SHIPPER_MUTATION_TYPES.SAVE_DANGEROUS_GOODS_INFO,
      resetShippingRequest: SHIPPER_MUTATION_TYPES.RESET_SHIPPING_REQUEST
    }),

    loadApiData: function() {
      this.isLoading = true;

      this.$apollo
        .query({
          query: GetPortsAndDangerousGoodsInfoQuery
        })
        .then(response => {
          const ports = response.data.ports;
          const dangerousGoodsInfo = response.data.DangerousGoodsInfo;
          this.updatePorts(ports);
          this.updateDangerousGoodsInfo(dangerousGoodsInfo);
          this.$toast.open({
            duration: 3000,
            position: "is-top-right",
            message: "Ports and Dangerous Goods loaded successfully.",
            type: "is-success"
          });
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            message: "Failed to load list of ports and dangerous good info",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    onContinueShippingRequest(savedShippingRequest) {
      this.$modal.open({
        parent: this,
        component: ConfirmContinueSavedRequestCard,
        hasModalCard: true,
        props: {
          continueSavedShippingRequest: this.continueSavedShippingRequest,
          savedShippingRequest
        }
      });
    },

    continueSavedShippingRequest(savedShippingRequest) {
      // Load the list of ports from the API
      if (!this.portsFromVuex.loaded || this.dangerousGoodsInfo.length < 1) {
        this.loadApiData();
      }

      this.continueShippingRequest(savedShippingRequest);
      this.$router.push({ name: "shippers-new-application" });
    },
    /**
     * View a shipping request's details.
     */
    viewShippingRequest: function(shippingRequestId) {
      this.$modal.open({
        parent: this,
        component: ViewShippingRequestDetails,
        hasModalCard: true,
        scroll: "keep",
        props: {
          id: shippingRequestId
        }
      });
    }
  }
};
</script>

<style scoped>
.modal-background {
  background-color: rgba(10, 10, 10, 0.2) !important;
}
.status {
  text-transform: capitalize;
  font-weight: bold;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: darkslategrey;
}

.approved,
.pending,
.rejected,
.completed {
  padding: 3px 8px;
  border-radius: 3px;
  display: inline;
}

.approved {
  background: rgba(144, 238, 144, 0.582);
}

.pending {
  background: rgba(253, 255, 110, 0.582);
}

.rejected {
  background: rgba(255, 110, 110, 0.582);
}
.completed {
  background: darkslategrey;
  color: white;
}

.action-item {
  display: flex;
  align-items: center;
}

.action-text {
  padding-left: 0.8em;
  font-weight: bold;
  font-size: 1em;
}
</style>
